import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import {
  finalize,
  map
} from 'rxjs/operators';
import { ChartsHttpService } from '../../services/charts-http.service';
import {
  forkJoin,
  of
} from 'rxjs';
import {
  ChartType,
  ChartTypeEnum,
  ILayoutList
} from '../../interfaces';
import { ChartsDashboardStateService } from '../../state/charts-dashboard-state.service';
import {PaymentWindowService} from '../../../payment-window.service';

@Component({
  selector: 'iv-live-charts-dashboard',
  templateUrl: './charts-dashboard.component.html',
  styleUrls: ['./charts-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChartsDashboardComponent implements OnInit, OnDestroy {

  constructor(
    private readonly chartsHttpService: ChartsHttpService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly chartsState: ChartsDashboardStateService,

    private readonly paymentWindowService: PaymentWindowService
  ) {
  }

  public hasLayouts: boolean;

  public ngOnInit(): void {
    window.parent.postMessage({ type: 'charts-page', displayed: true }, '*');
    this.paymentWindowService.showPaymentWindow();
    forkJoin({
      layouts: this.chartsHttpService.getLayouts()
        .pipe(map((layouts: ILayoutList) => layouts.layoutsList)),
      allParameters: this.chartsHttpService.getAllParameters(),
      chartsTypes: this.chartsHttpService.getAllCharts()
        // TODO: Необходимо добавить "SINGLE_CONTRACT_ANALYZER" на бекенд
        .pipe(map((chartsTypes: ChartType[]) => [
          ...chartsTypes.slice(0, 2),
          ChartTypeEnum.SINGLE_CONTRACT_ANALYZER,
          ...chartsTypes.slice(2, chartsTypes.length)
        ]))
    })
      .pipe(
        finalize(() => {
          this.hasLayouts = true;
          this.changeDetectorRef.detectChanges();
        }))
      .subscribe((obs) => {
        this.chartsState.allParameters = obs.allParameters;
        this.chartsState.layouts$ = of(obs.layouts);
        this.chartsState.allChartTypes$ = of(obs.chartsTypes);
        this.chartsState.initDashboard(obs.layouts);
      });
  }

  ngOnDestroy(): void {
    window.parent.postMessage({type: 'charts-page', displayed: false}, '*');
  }
}
